var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Facebook_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24 12c0-6.628-5.372-12-12-12S0 5.372 0 12c0 5.625 3.877 10.35 9.103 11.648v-7.982H6.628V12h2.475v-1.58c0-4.082 1.847-5.976 5.86-5.976.759 0 2.071.15 2.61.3v3.319a16 16 0 0 0-1.387-.047c-1.969 0-2.728.745-2.728 2.68V12h3.919l-.675 3.666h-3.249v8.245C19.397 23.194 24 18.136 24 12"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Facebook_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgFacebook;